import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const StyledBox = styled(Box)(
  ({ theme, marginsides, marginbottom }) => `

  margin: 0 ${theme.DS_spacing(['md'])};
  
   ${theme.breakpoints.up('md')} {
   margin: 0 ${theme.DS_spacing(['lgx'])};
  }

  ${theme.breakpoints.up('lg')} {

   margin: 0 ${marginsides} ${marginbottom} !important;
  }
     
  z-index: 2;
  position: relative;
`,
);
